import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './EnhancedSupabaseAuthContext';

/**
 * 🌐 PAGES PUBLIQUES D'AUTHENTIFICATION (connexion, inscription, mot de passe oublié…)
 * - Visiteur : la page s'affiche
 * - Utilisateur déjà connecté : redirection vers la page demandée (ou le tableau de bord)
 * L'écran d'attente ne s'affiche que pendant la vérification initiale de la session : pendant une
 * tentative de connexion, le formulaire reste affiché (les champs saisis ne sont pas perdus).
 */
const PublicRoute = ({ children, redirectTo = '/dashboard', redirectState }) => {
  const { user, isInitialized } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50" role="status" aria-live="polite">
        <div className="flex items-center gap-3 text-gray-600">
          <span className="h-6 w-6 animate-spin rounded-full border-2 border-blue-200 border-t-blue-700" aria-hidden="true" />
          <span className="font-medium">Vérification de votre session…</span>
        </div>
      </div>
    );
  }

  if (user) {
    return <Navigate to={location.state?.from || redirectTo} replace state={redirectState} />;
  }

  return children;
};

export default PublicRoute;
